import FAQCard from "../components/faq.component";

const FAQ = () => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center "
      id="faq"
      style={{ minHeight: "100vh", scrollMarginTop: 40 }}
    >
      <div className="container d-flex flex-column justify-content-center align-items-center">
        <h1 className="primary-h" data-aos="fade-up" data-aos-duration="700">
          FAQ
        </h1>
        <br />
        <div
          className="faq-card"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="700"
        >
          <FAQCard
            title="What is an NFT?"
            text="An NFT is a non-fungible token. They represent digital collectibles, and can be in the form of illustrations, and other media."
          />
        </div>
        <div
          className="faq-card"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-duration="700"
        >
          <FAQCard
            title="What is the total supply?"
            text="There will be a total of 8,500 Laser Octopus."
          />
        </div>
        <div
          className="faq-card"
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="700"
        >
          <FAQCard
            title="What is the network?"
            text="The network will be Ethereum (ETH)."
          />
        </div>
        <div
          className="faq-card"
          data-aos="fade-up"
          data-aos-delay="250"
          data-aos-duration="700"
        >
          <FAQCard
            title="When will the Laser Octopus Launch?"
            text="Laser Octopus will launch on Sep 18, 2022."
          />
        </div>
        <div
          className="faq-card"
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-duration="700"
        >
          <FAQCard
            title="What is the mint price?"
            text="One Laser Octopus will cost 0.05 ETH."
          />
        </div>
        <div
          className="faq-card"
          data-aos="fade-up"
          data-aos-delay="350"
          data-aos-duration="700"
        >
          <FAQCard
            title="How many can I mint per wallet?"
            text="You can mint a total of 50 Laser Octopus per wallet."
          />
        </div>
      </div>
    </div>
  );
};

export default FAQ;
